module.exports = __webpack_public_path__ + "79edd64711bf5426459d62b477deb1df.jpg";